import React from 'react'
import moment from 'moment'
import { stringToFormat } from '../../../../utilities/date'

const AutomaticTrackingMessage = (props) => {
  return (
    <div>
      {props.tracking.newDay && (
        <div className="date-separator">
          <span>{stringToFormat(props.tracking.created_at, 'D MMMM')}</span>
        </div>
      )}
      <div className="note">
        <div className="component-chatListItem">
          <div className="text">
            <div className="header">
              <div className="title">
                <div> {`Seguimiento automático para enviar el ${moment(props.tracking.to_send_at).format('L')}:`} </div>
                <div>
                  <b>{props.tracking.message}</b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AutomaticTrackingMessage
